module.exports = __webpack_public_path__ + "static/media/play.84f25a4d.svg";